/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const EnvelopeBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M11.171 2.998C11.061 3.311 11 3.648 11 4H2.5a.5.5 0 00-.492.41L2 4.5v8a.5.5 0 00.41.492L2.5 13h11a.5.5 0 00.492-.41L14 12.5V7c.351 0 .688-.06 1-.171V12.5a1.5 1.5 0 01-1.356 1.493L13.5 14h-11a1.5 1.5 0 01-1.493-1.356L1 12.5v-8a1.5 1.5 0 011.356-1.493L2.5 3l8.671-.002zM3.698 5.041l.08.043L8 7.898l3.458-2.304c.18.287.409.542.674.753L8.277 8.916a.5.5 0 01-.467.047l-.087-.047-4.5-3a.5.5 0 01.475-.875zM14 2a2 2 0 110 4 2 2 0 010-4z"
        />
    </AccessibleSVG>
);

export default EnvelopeBadge16;
